"use strict";

exports.__esModule = true;
exports.FormGlyph = exports.Form = void 0;

var _form = _interopRequireDefault(require("./form"));

exports.Form = _form["default"];

var _formGlyph = _interopRequireDefault(require("./form-glyph"));

exports.FormGlyph = _formGlyph["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }